import { useLanguage } from "../i18n/LanguageContext";
import "./CoursesSection.css";

const INSTRUMENT_ICONS = {
  erhu: (
    <svg viewBox="0 0 64 64" className="course-icon-svg" aria-hidden="true">
      <line x1="32" y1="8" x2="32" y2="56" stroke="currentColor" strokeWidth="1.5" fill="none" />
      <line x1="28" y1="8" x2="36" y2="8" stroke="currentColor" strokeWidth="1.5" />
      <ellipse cx="32" cy="44" rx="10" ry="8" stroke="currentColor" strokeWidth="1.5" fill="none" />
      <path d="M22 44 Q22 20 32 16" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.5" />
    </svg>
  ),
  pipa: (
    <svg viewBox="0 0 64 64" className="course-icon-svg" aria-hidden="true">
      <ellipse cx="32" cy="38" rx="12" ry="16" stroke="currentColor" strokeWidth="1.5" fill="none" />
      <line x1="32" y1="22" x2="32" y2="10" stroke="currentColor" strokeWidth="1.5" />
      <line x1="28" y1="10" x2="36" y2="10" stroke="currentColor" strokeWidth="1.5" />
      <line x1="26" y1="34" x2="38" y2="34" stroke="currentColor" strokeWidth="0.8" opacity="0.4" />
      <line x1="26" y1="40" x2="38" y2="40" stroke="currentColor" strokeWidth="0.8" opacity="0.4" />
    </svg>
  ),
  zhongruan: (
    <svg viewBox="0 0 64 64" className="course-icon-svg" aria-hidden="true">
      <circle cx="32" cy="38" r="14" stroke="currentColor" strokeWidth="1.5" fill="none" />
      <line x1="32" y1="24" x2="32" y2="10" stroke="currentColor" strokeWidth="1.5" />
      <line x1="28" y1="10" x2="36" y2="10" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="32" cy="38" r="3" stroke="currentColor" strokeWidth="0.8" fill="none" opacity="0.4" />
    </svg>
  ),
};

function CourseCard({ course }) {
  return (
    <article className="course-card">
      <div className="course-icon">
        {INSTRUMENT_ICONS[course.icon]}
      </div>
      <div className="course-content">
        <h3 className="course-instrument">
          {course.instrument}
          <span className="course-chinese-name"> {course.chineseName}</span>
        </h3>
        <p className="course-levels">{course.levels}</p>
        <p className="course-description">{course.description}</p>
      </div>
    </article>
  );
}

export default function CoursesSection() {
  const { t } = useLanguage();

  return (
    <section id="courses" className="courses-section">
      <div className="section-header">
        <h2 className="section-title">{t.courses.sectionTitle}</h2>
        <div className="section-divider" aria-hidden="true">
          <span className="divider-dot" />
          <span className="divider-line" />
          <span className="divider-dot" />
        </div>
        <p className="courses-subtitle">{t.courses.sectionSubtitle}</p>
      </div>

      <div className="courses-grid">
        {t.courses.items.map((course, i) => (
          <CourseCard key={i} course={course} />
        ))}
      </div>

      <ul className="courses-features">
        {t.courses.features.map((feature, i) => (
          <li key={i} className="feature-item">{feature}</li>
        ))}
      </ul>
    </section>
  );
}
